import { SettingConstant } from "shared/constants/setting-constant"

export const freightEnquiryUrl = "https://www.estorelogistics.com.au/freight-enquiry/"
export const helpUrl = "https://userguide.estorelogistics.com.au"

const endPointPrefix = SettingConstant.APP_SERVICE_URL

export const environmentVariables = `${endPointPrefix}environment-variables`

export const user = {
  getUserPermissions: `${SettingConstant.UAM_SERVICE_URL}UserPermissions`,
  getUserConfigs: `${SettingConstant.UAM_SERVICE_URL}user-configs`,
  addUserConfig: `${SettingConstant.UAM_SERVICE_URL}user-config`,
  updateUserConfig: `${SettingConstant.UAM_SERVICE_URL}user-config`,
  deleteUserConfig: `${SettingConstant.UAM_SERVICE_URL}user-config`,
}

export const filterCriteria = { list: `${endPointPrefix}FilterCriteria` }
export const carrierService = `${endPointPrefix}CarrierService`

export const product = {
  post: `${endPointPrefix}item`,
  put: `${endPointPrefix}item`,
  list: `${endPointPrefix}ProductList?activeonly=Y`,
  search: `${endPointPrefix}products`,
  get: `${endPointPrefix}ProductDetails`,
  movement: `${endPointPrefix}ProductStockMovement`,
  searchInventory: `${endPointPrefix}inventory-search`,
}

export const salesOrderSearch = { list: `${endPointPrefix}OrderSearch` }

export const shipment = {
  list: "shipment",
  post: `${endPointPrefix}shipment`,
  put: `${endPointPrefix}shipment`,
  getDeliveryInformation: `${endPointPrefix}shipment_information`,
  getProductInformation: `${endPointPrefix}shipment_information`,
  delete: `${endPointPrefix}order`,
  batchDelete: `${endPointPrefix}batch-orders`,
  setOnOrOffHold: `${endPointPrefix}set-on-off-hold`,
}

export const inbound = { list: `${endPointPrefix}asnsearch` }

export const receipt = {
  list: "receipt",
  post: `${endPointPrefix}receipt`,
  put: `${endPointPrefix}receipt`,
  getDeliveryInformation: `${endPointPrefix}AsnDetail`,
  getProductInformation: `${endPointPrefix}AsnProductDetail`,
  delete: `${endPointPrefix}Asns`,
}

export const returns = {
  list: `${endPointPrefix}returns`,
}

export const company = { list: `${endPointPrefix}CompanyList` }

export const dashboard = {
  receipt: `${SettingConstant.DASHBOARD_SERVICE_URL}receipts-summary`,
  order: `${SettingConstant.DASHBOARD_SERVICE_URL}ordersummary`,
  analytics_inbound: `${SettingConstant.DASHBOARD_SERVICE_URL}analytics-inbound`,
  analytics_outbound: `${SettingConstant.DASHBOARD_SERVICE_URL}analytics-outbound`,
  slow_moving_lines: `${SettingConstant.DASHBOARD_SERVICE_URL}SlowMovingLines`,
  lowest_days_of_stock: `${SettingConstant.DASHBOARD_SERVICE_URL}LowestDaysOfStock`,
}

export const bom = {
  post: `${endPointPrefix}bom`,
  put: `${endPointPrefix}bom`,
  list: `${endPointPrefix}BOMList`,
  search: `${endPointPrefix}Boms`,
  getDetail: `${endPointPrefix}BomDetails`,
  deleteDetail: `${endPointPrefix}BomDetails`,
}

export const dgItemProfile = {
  search: `${endPointPrefix}dg-item-profiles`,
  getDetail: `${endPointPrefix}dg-item-profile-details`,
  post: `${endPointPrefix}dg-item-profile`,
  put: `${endPointPrefix}dg-item-profile`,
  delete: `${endPointPrefix}dg-item-profile`,
}

export const notification = `${SettingConstant.UAM_SERVICE_URL}get-notifications`

export const uploadHistory = {
  post: `${SettingConstant.UPLOAD_HISTORY_URL}create`,
  list: `${SettingConstant.UPLOAD_HISTORY_URL}read`,
}

export const companyWarehouses = `${endPointPrefix}get-config-warehouses`

export const sendEmail = `${endPointPrefix}send-email`

export const sendExpressLog = `${endPointPrefix}send-express-log`
